// extracted by mini-css-extract-plugin
export default {"skillsInsights":"skills_insights_section-module___skillsInsights___c10fb32f","explorer":"skills_insights_section-module___explorer___ad3c8608"};